import {handleActions} from 'redux-actions';
import {Record} from 'immutable';
import moment from 'moment-timezone';

import * as Actions from './actions';

const ExportCSVModal = Record({
    isVisible: false,
    loading: false,
    csvLink: '',
    csvType: '',
    institutionId: undefined,
    from: moment().startOf('month').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
});

export default handleActions(
    {
        [Actions.show.type]: (state, {payload}) =>
            new ExportCSVModal({
                isVisible: true,
                csvType: payload.csvType,
                institutionId: payload.institutionId,
            }),
        [Actions.getCSVLink.type]: (state, {payload}) =>
            state.merge({
                loading: true,
                csvLink: '',
                from: payload.from,
                to: payload.to,
            }),
        [Actions.getCSVLinkSuccess.type]: (state, {payload}) =>
            state.merge({
                loading: false,
                csvLink: payload.csv,
            }),
        [Actions.clearCSVLink.type]: state => state.merge({csvLink: ''}),
        [Actions.hide.type]: () => new ExportCSVModal(),
    },
    new ExportCSVModal(),
);
